import { render, staticRenderFns } from "./flowHistory.vue?vue&type=template&id=328d6371"
import script from "./flowHistory.vue?vue&type=script&lang=js"
export * from "./flowHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports